import { xhrRequest, afterXhrRequest, adjustStickyHeader } from '../../shared/helpers'
import { closeInlineForms, addFormHandlers } from './messageHelpers';

export default class extends Controller {
  static targets = ['messageHeader', 'openMessageHeader', 'message', "editLink"];

  connect() {
    this.data.get('openOnLoad') && this.edit()
    this.makeOpenMessageHeaderSticky()
    App.Helpers.listenToCustomEvent(document, 'update-success', this.reloadIfMatchingID.bind(this));
  }

  toggleMobileActions(event) {
    event.preventDefault()
    this.messageHeaderTarget.classList.toggle('mobile-actions-visible')
  }

  edit(event) {
    event && event.preventDefault()
    App.Helpers.ajaxRequest({ url: this.editURL, successHandler: this.openEditForm.bind(this) });
  }

  delete(event) {
    event.preventDefault()
    confirm('Are you sure?') &&
      xhrRequest(this.deleteURL, 'delete', {})
        .then(this.removeDeletedMessage.bind(this))
  }

  //
  // INTERNAL USE
  //

  reloadIfMatchingID(event) {
    if (event.detail.message_id == this.messageID) {
      event.detail.remove ? this.removeDeletedMessage() : App.Helpers.ajaxRequest({
        url: this.url,
        successHandler: this.replaceMessageCardWith.bind(this)
      })
    }
  }

  replaceMessageCardWith(response) {
    this.element.innerHTML = response.html;
  }

  openEditForm(response) {
    closeInlineForms()
    const container = document.createElement('div')
    container.className = `inline-msg-container ${this.formClass}`
    container.innerHTML = response
    addFormHandlers(container)
    App.Helpers.replaceElement(this.messageTarget, container);
  }

  removeDeletedMessage(response) {
    afterXhrRequest(response)
    const messageElement = this.messageTarget.closest('.messages--message-div')
    messageElement.remove();
  }

  makeOpenMessageHeaderSticky() {
    if (this.openMessageHeaderTargets.length > 0) {
      window.addEventListener('scroll', () => adjustStickyHeader({
        elementTop: this.topOfMessageCard,
        elementBottom: this.bottomOfMessageCard,
        element: this.openMessageHeader,
        width: this.messageCardWidth
      }))
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get topOfMessageCard() {
    return this.element.getBoundingClientRect().top + window.scrollY
  }

  get bottomOfMessageCard() {
    return this.topOfMessageCard + this.element.offsetHeight
  }

  get messageCardWidth() {
    return this.element.offsetWidth
  }

  get openMessageHeader() {
    return this.openMessageHeaderTargets.length > 0 ? this.openMessageHeaderTarget : null
  }

  get url() {
    return this.data.get('url');
  }

  get messageID() {
    return this.data.get('id');
  }

  get editURL() {
    return this.editLinkTarget.href;
  }

  get deleteURL() {
    return this.data.get('url');
  }

  get formClass() {
    return this._formClass || 'edit-inline-msg';
  }

  set formClass(val) {
    this._formClass = val;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/messages/message-controller.js